import 'polyfills';
import 'main';
import 'protoTypeExtensions/Object';

export {};
